export const TITLE = 'Request entitlement restoration online';
export const SUBTITLE =
  'Education Benefit Entitlement Restoration Request Due to School Closure, Program Suspension or Withdrawal (VA Form 22-0989)';

export const OMB_RES_BURDEN = 15;
export const OMB_NUMBER = '2900-0859';
export const OMB_EXP_DATE = '05/31/2027';
